import { render, staticRenderFns } from "./templateEmail.vue?vue&type=template&id=47a5fb33&scoped=true"
import script from "./templateEmail.vue?vue&type=script&lang=js"
export * from "./templateEmail.vue?vue&type=script&lang=js"
import style0 from "./templateEmail.vue?vue&type=style&index=0&id=47a5fb33&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a5fb33",
  null
  
)

export default component.exports